import { BreadcrumbsConfigItem } from "./config";

export const makeTitleFromBreadcrumbs = (config: BreadcrumbsConfigItem): string =>
  [config.label, ...(config.crumbs || []).map((item) => item.label).reverse(), "Skyportal"].join(" - ");
